import React, { useMemo, useState, useCallback } from 'react';

import TaskSingle from 'components/task-single';

export const OverlayTaskContext = React.createContext();

export const OverlayTaskProvider = ({ children }) => {
    const [currentTask, setCurrentTask] = useState(null);

    const openTask = useCallback((taskId, subtaskId, options)=> {
        setCurrentTask({
            taskId,
            subtaskId,
            options
        });
    }, []);

    const closeTask = useCallback(() => {
        setCurrentTask(null);
    }, []);

    const value = useMemo(() => ({
        openTask,
        closeTask
    }), [openTask, closeTask]);

    return (
        <OverlayTaskContext.Provider value={value}>
            { children }

            <TaskSingle
                id={currentTask?.taskId}
                subtaskId={currentTask?.subtaskId}
                section={currentTask?.options?.section}
                noRedirect={true}
                shouldChangeUrl={false}
                greaterZIndex={true}
                onClose={closeTask}
            />
        </OverlayTaskContext.Provider>
    )
};
